module.exports = __webpack_public_path__ + "img/组5317@2x.d8a9628f.png";